// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/chunk-" + {"48":"3790c58e19835a96","346":"abc8d34f6d66b1b4"}[chunkId] + ".js";
};